<template>
  <jet-authentication-card>
    <card-header>Verify Email</card-header>
    <template #logo>
      <jet-authentication-card-logo />
    </template>
    <jet-validation-errors class="mb-4 px-6 pt-4" />
    <div class="bg-white border border-t-0 text-center">
      <div class="px-4 py-5 sm:p-6">
        <div
          v-if="status === 'verification-link-sent'"
          class="font-medium mb-2 text-sm text-green-600"
        >
          A new verification link has been sent to the email address you provided during
          registration
        </div>
        <h3 class="text-lg leading-6 font-medium text-gray-900">Thank you for signing up!</h3>

        <div class="mt-2 max-w-xl m-auto text-sm text-gray-500">
          <p>
            Before getting started you need to verify your email address. Please verify by clicking
            on the link in the email we just sent you. If you didn't receive an email yet, we will
            gladly send you another.
          </p>
        </div>
        <div class="mt-5">
          <inertia-link
            :href="route('verification.send')"
            method="post"
            as="button"
            type="button"
            class="
              inline-flex
              items-center
              px-4
              py-2
              border border-transparent
              text-xs
              uppercase
              font-medium
              rounded-md
              text-white
              bg-vice-teal-700
              hover:bg-vice-teal-200
              focus:outline-none
              focus:ring-2 focus:ring-offset-2 focus:ring-vice-teal-500
            "
          >
            Resend Verification Email
          </inertia-link>
        </div>
        <div class="mt-1">
          <inertia-link
            :href="route('clinician.logout')"
            method="post"
            class="
              inline-flex
              items-center
              rounded-md
              border border-gray-300
              bg-white
              px-4
              py-2
              text-base
              font-medium
              text-gray-700
              shadow-sm
              hover:bg-gray-50
              focus:outline-none
              focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2
            "
          >
            Logout
          </inertia-link>
        </div>
      </div>
    </div>
  </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import CardHeader from '@/Components/Cards/CardHeader.vue';

export default {
  components: {
    CardHeader,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetValidationErrors,
  },

  props: {
    canResetPassword: Boolean,
    status: String,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    };
  },

  methods: {
    submit() {
      this.form
        .transform((data) => ({
          ...data,
          remember: this.form.remember ? 'on' : '',
        }))
        .post(this.route('clinician.login'), {
          onFinish: () => this.form.reset('password'),
        });
    },
  },
  computed: {
    // a computed getter
    entityName() {
      return (
        this.$page.props.clinicianRole.charAt(0).toUpperCase() +
        this.$page.props.clinicianRole.slice(1)
      );
    },
  },
};
</script>
